import { cardSchemesConstants } from "../constants/action.constants";
import { cardSchemeService } from "../services/cardschemes.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const cardSchemeActions = {
  addCardScheme,
  getAllCardSchemes,
  getCardScheme,
  resetCardScheme,
  resetAddCardScheme
};

function getAllCardSchemes() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await cardSchemeService.getAllCardSchemes();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CARD_SCHEMES
        )
      );
    }
  };

  function request() {
    return { type: cardSchemesConstants.GET_CARDSCHEMES_REQUEST };
  }
  function success(response) {
    return { type: cardSchemesConstants.GET_CARDSCHEMES_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardSchemesConstants.GET_CARDSCHEMES_FAILURE, error };
  }
}

function getCardScheme(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await cardSchemeService.getCardScheme(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_CARD_SCHEME}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: cardSchemesConstants.VIEW_CARDSCHEME_REQUEST, id };
  }
  function success(response) {
    return { type: cardSchemesConstants.VIEW_CARDSCHEME_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardSchemesConstants.VIEW_CARDSCHEME_FAILURE, error };
  }
}

function addCardScheme(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await cardSchemeService.addCardScheme(requestBody);
      response && dispatch(success(response));
      dispatch(getAllCardSchemes());
      if (requestBody.id) {
        history.push(routeConstants.CARDSCHEMES.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_CARD_SCHEME : message.ADD_CARD_SCHEME
        )
      );
      dispatch(resetAddCardScheme());
      dispatch(resetCardScheme());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_CARD_SCHEME : message.ADD_CARD_SCHEME
        )
      );
    }
  };

  function request(requestBody) {
    return { type: cardSchemesConstants.ADD_CARDSCHEME_REQUEST, requestBody };
  }
  function success(response) {
    return { type: cardSchemesConstants.ADD_CARDSCHEME_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardSchemesConstants.ADD_CARDSCHEME_FAILURE, error };
  }
}

function resetCardScheme() {
  return { type: cardSchemesConstants.VIEW_CARDSCHEME_RESET };
}

function resetAddCardScheme() {
  return { type: cardSchemesConstants.ADD_CARDSCHEME_RESET };
}
